var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"o-project-nav-owner"},[_c('li',[_c('router-link',{attrs:{"to":{
                name: 'project-main',
                params: {
                    projectUuid: _vm.projectUuid,
                },
            }}},[_c('i',{staticClass:"uil uil-cog"}),_vm._v("\n            "+_vm._s(_vm.$t('app.Project'))+"\n        ")])],1),_c('li',[_c('router-link',{attrs:{"to":{
                name: 'project-resources',
                params: {
                    projectUuid: _vm.projectUuid,
                },
            }}},[_c('i',{staticClass:"uil uil-package"}),_vm._v("\n            "+_vm._s(_vm.$t('app.Resources'))+"\n        ")])],1),_c('li',[_c('router-link',{attrs:{"to":{
                name: 'project-translations',
                params: {
                    projectUuid: _vm.projectUuid,
                },
            }}},[_c('i',{staticClass:"uil uil-schedule"}),_vm._v("\n            "+_vm._s(_vm.$t('app.Translations'))+"\n        ")])],1),_c('li',[_c('router-link',{attrs:{"to":{
                name: 'project-notifs',
                params: {
                    projectUuid: _vm.projectUuid,
                },
            }}},[_c('i',{staticClass:"uil uil-message"}),_vm._v("\n            "+_vm._s(_vm.$t('app.Notifs'))+"\n        ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }